import { useState } from "react";
import DataTable from "react-data-table-component";
import { useFetchData } from "../../hooks/useFetchData";
import { customStyles } from "../../utils/data/essential";
import { houseColumns } from "../../utils/columns/houses";
import UpdateHouseDetails from "./UpdateHouseDetails";
const HouseForAccount = ({ accountId }) => {
  const [row, setRow] = useState()
  const [show, setShow] = useState(false)
  const user = JSON.parse(localStorage.getItem("user"))
  const roles = JSON.parse(localStorage.getItem("roles"));
  const url = `houses?accountId=${accountId}`;
  const { data } = useFetchData(["house-for-account"], url,true,user);
  const handleOpenModal = () => setShow(true);
  const columns = houseColumns(roles, handleOpenModal, setRow);
  
  return (
    <>
      <div className='d-flex justify-content-center mt-4'>
        <h4 className='mt-3' style={{ fontWeight: 600 }}>
          {`House${data?.length > 1 ? "s" : ""} For this Account`}
        </h4>
      </div>
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={data}
          responsive={true}
          customStyles={customStyles}
          highlightOnHover
          striped
          noHeader
        />
      </div>
      <UpdateHouseDetails dataToUpdate={row} show={show} onHide={()=>setShow(false)} />
    </>
  );
};

export default HouseForAccount;
